module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ecBS6"))).then(() => module.bundle.root('f4eak'));